import { jsxs as c, jsx as s, Fragment as m } from "react/jsx-runtime";
import _, { useId as x } from "react";
import { c as y } from "./clsx-OuTLNxxd.js";
import { c as f } from "./createLucideIcon-WU3cnAkb.js";
import './Input.css';/**
 * @license lucide-react v0.367.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const E = f("CircleAlert", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
]), h = "_Input_xzus2_32", v = "_error_xzus2_60", g = "_InputWrapper_xzus2_67", b = "_ErrorIcon_xzus2_72", z = "_ErrorMessage_xzus2_83", r = {
  Input: h,
  error: v,
  InputWrapper: g,
  ErrorIcon: b,
  ErrorMessage: z
}, N = _.forwardRef(
  ({ "aria-describedby": i, "aria-invalid": t, className: d, errors: o, type: p, ...l }, u) => {
    const e = o !== void 0 && o.length > 0, a = `${x()}-error`, I = [i, e ? a : void 0].filter(Boolean).join(" ") || void 0;
    return /* @__PURE__ */ c("div", { className: r.InputWrapper, "data-cxy-name": "input", children: [
      /* @__PURE__ */ s(
        "input",
        {
          "aria-describedby": I,
          "aria-invalid": t ?? (e || void 0),
          className: y(r.Input, e ? r.error : "", d),
          ref: u,
          type: p,
          ...l
        }
      ),
      e && /* @__PURE__ */ c(m, { children: [
        /* @__PURE__ */ s(E, { "aria-hidden": !0, className: r.ErrorIcon }),
        /* @__PURE__ */ s("div", { id: a, children: o.map((n) => /* @__PURE__ */ s("p", { className: r.ErrorMessage, children: n }, n)) })
      ] })
    ] });
  }
);
N.displayName = "Input";
export {
  N as I
};
